//
//
//
//
//
//
//
//

export default {
  name: 'AppCarrousel',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
